import React from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';

const TechPagination = ({ page, totalPages, total, onPageChange }) => {
  if (totalPages <= 1) return null;

  return (
    <div className="flex flex-col sm:flex-row items-center justify-between gap-3 pt-4">
      <p className="text-xs text-slate-500">
        Page {page} of {totalPages} · {total} total
      </p>
      <div className="flex items-center gap-2">
        <button
          type="button"
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
          className="flex items-center gap-1 px-3 py-2 rounded-lg bg-slate-800 text-slate-300 text-sm disabled:opacity-40 touch-manipulation"
        >
          <FiChevronLeft size={16} />
          Prev
        </button>
        <button
          type="button"
          disabled={page >= totalPages}
          onClick={() => onPageChange(page + 1)}
          className="flex items-center gap-1 px-3 py-2 rounded-lg bg-slate-800 text-slate-300 text-sm disabled:opacity-40 touch-manipulation"
        >
          Next
          <FiChevronRight size={16} />
        </button>
      </div>
    </div>
  );
};

export default TechPagination;
